import { lazy, Suspense, type ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import RootLayout from '@/layouts/RootLayout'
import NotFoundPage from '@/pages/NotFoundPage'
import LoadingSpinner from '@/components/ui/LoadingSpinner'

function wrap(factory: () => Promise<{ default: ComponentType }>) {
  const Component = lazy(factory)
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Component />
    </Suspense>
  )
}

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <NotFoundPage />,
    children: [
      { index: true,              element: wrap(() => import('@/pages/HomePage')) },
      { path: 'ferienwohnung',    element: wrap(() => import('@/pages/FerienwohnungPage')) },
      { path: 'lage',             element: wrap(() => import('@/pages/LagePage')) },
      { path: 'preise',           element: wrap(() => import('@/pages/PreisePage')) },
      { path: 'anreise',          element: wrap(() => import('@/pages/AnreisePage')) },
      { path: 'kontakt',          element: wrap(() => import('@/pages/KontaktPage')) },
      { path: 'impressum',        element: wrap(() => import('@/pages/ImpressumPage')) },
      { path: 'datenschutz',      element: wrap(() => import('@/pages/DatenschutzPage')) },
    ],
  },
]
